// extracted by mini-css-extract-plugin
export default {"container":"RJVuw0aINPjzaQbBK7Du"};